import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["icon", "disabled", "size"];
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
export function TextToolbarIcon(_ref) {
  let {
      icon,
      disabled,
      size = '200'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconHolder, Object.assign({
    padding: "0",
    margin: "0",
    alignItems: "center",
    icon: icon,
    color: disabled ? 'icon-core-disabled' : 'icon-core-default',
    size: size
  }, rest));
}